/* WINECOM Sofortsuche (ersetzt Boost Instant Search)
   Desktop: Vorschlaege unter dem Header-Suchfeld. Mobil: Vollbild-Suche.
   Daten: Shopify Predictive Search, gerendert ueber sections/winecom-predictive-search.liquid */
(function () {
  'use strict';

  var SECTION = 'winecom-predictive-search';
  var MIN = 2;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var timer, ctrl, drop, full, current;

  function suggestUrl(q) {
    return root + 'search/suggest?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,query&resources[limit]=6&resources[limit_scope]=each' +
      '&resources[options][fields]=title,vendor,product_type,tag,variants.sku' +
      '&resources[options][unavailable_products]=last&section_id=' + SECTION;
  }
  function searchUrl(q) {
    return root + 'search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
  }

  function load(q, target) {
    clearTimeout(timer);
    if (q.trim().length < MIN) { target.innerHTML = ''; target.hidden = true; return; }
    timer = setTimeout(function () {
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      target.classList.add('is-loading');
      fetch(suggestUrl(q), { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var res = doc.querySelector('[data-wc-ps-res]');
          target.innerHTML = res ? res.outerHTML : '';
          target.hidden = !res;
          target.classList.remove('is-loading');
        })
        .catch(function (e) { if (!e || e.name !== 'AbortError') target.classList.remove('is-loading'); });
    }, 180);
  }

  /* ---------- Desktop: Fenster unter dem Suchfeld ---------- */
  function dropdown() {
    if (drop) return drop;
    drop = document.createElement('div');
    drop.className = 'wc-ps wc-ps--drop';
    drop.hidden = true;
    drop.setAttribute('role', 'region');
    drop.setAttribute('aria-label', 'Suchvorschläge');
    document.body.appendChild(drop);
    return drop;
  }
  function placeDrop(input) {
    var r = input.getBoundingClientRect();
    var d = dropdown();
    var w = Math.min(760, window.innerWidth - 32);
    var left = Math.max(16, Math.min(r.left, window.innerWidth - w - 16));
    d.style.top = (r.bottom + window.pageYOffset + 8) + 'px';
    d.style.left = left + 'px';
    d.style.width = w + 'px';
  }
  function closeDrop() { if (drop) { drop.hidden = true; } current = null; }

  /* ---------- Mobil: Vollbild ---------- */
  function fullscreen() {
    if (full) return full;
    full = document.createElement('div');
    full.className = 'wc-ps wc-ps--full';
    full.hidden = true;
    full.setAttribute('role', 'dialog');
    full.setAttribute('aria-modal', 'true');
    full.setAttribute('aria-label', 'Suche');
    full.innerHTML =
      '<form class="wc-ps__bar" action="' + root + 'search" method="get" role="search">' +
        '<input type="hidden" name="type" value="product"><input type="hidden" name="options[prefix]" value="last">' +
        '<label class="wc-ps__field"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>' +
        '<input type="search" name="q" placeholder="Wein, Weingut, Rebsorte, Region" aria-label="Suchbegriff" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"></label>' +
        '<button type="button" class="wc-ps__close" aria-label="Suche schließen">Abbrechen</button>' +
      '</form>' +
      '<div class="wc-ps__body" hidden></div>';
    document.body.appendChild(full);
    var input = full.querySelector('input[name="q"]');
    var body = full.querySelector('.wc-ps__body');
    input.addEventListener('input', function () { load(input.value, body); });
    full.querySelector('.wc-ps__close').addEventListener('click', closeFull);
    return full;
  }
  function openFull(value) {
    var f = fullscreen();
    var input = f.querySelector('input[name="q"]');
    f.hidden = false;
    document.documentElement.classList.add('wc-ps-lock');
    input.value = value || '';
    input.focus();
    if (input.value) load(input.value, f.querySelector('.wc-ps__body'));
  }
  function closeFull() {
    if (!full) return;
    full.hidden = true;
    document.documentElement.classList.remove('wc-ps-lock');
  }

  function isMobileInput(input) {
    return !!(input.closest('#mobile-header') || input.closest('.search-mobile-box') || input.classList.contains('mob_input'));
  }
  function isHeaderInput(el) {
    if (!el || el.name !== 'q' || !el.form) return false;
    if (el.closest('.wc-listing') || el.closest('.wc-ps')) return false;
    var action = el.form.getAttribute('action') || '';
    return /\/search\/?$/.test(action);
  }

  /* ---------- Ereignisse ---------- */
  /* Vantage-Vorschlaege bleiben aktiv (wegen der Header-Optik), werden aber
     abgefangen: Ereignisse im Header-Suchfeld gehen nur an die WINECOM-Sofortsuche. */
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (!isHeaderInput(t)) return;
    e.stopPropagation();
    if (isMobileInput(t) && window.innerWidth <= 980) {
      t.blur();
      openFull(t.value);
      return;
    }
    t.setAttribute('autocomplete', 'off');
    if (t.value.trim().length >= MIN) { current = t; placeDrop(t); load(t.value, dropdown()); }
  }, true);

  ['focus', 'keyup', 'keydown'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (isHeaderInput(e.target) && !(type === 'keydown' && e.key === 'Escape')) e.stopPropagation();
    }, true);
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!isHeaderInput(t)) return;
    e.stopPropagation();
    if (isMobileInput(t) && window.innerWidth <= 980) return;
    current = t;
    placeDrop(t);
    load(t.value, dropdown());
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var mbox = t.closest('.search-mobile-box');
    if (mbox && window.innerWidth <= 980 && !t.closest('.wc-ps')) {
      e.preventDefault();
      var mi = mbox.querySelector('input[name="q"]');
      openFull(mi ? mi.value : '');
      return;
    }
    if (drop && !drop.hidden && !drop.contains(t) && !(current && current.contains(t)) && t !== current) closeDrop();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (full && !full.hidden) { closeFull(); return; }
    if (drop && !drop.hidden) { closeDrop(); }
  });

  window.addEventListener('resize', function () { if (current && drop && !drop.hidden) placeDrop(current); });

  /* Enter im Header-Suchfeld fuehrt immer zur Produktsuche */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement)) return;
    var q = f.querySelector('input[name="q"]');
    if (!q || !isHeaderInput(q)) return;
    e.preventDefault();
    if (q.value.trim()) location.href = searchUrl(q.value.trim());
  });
})();
